import { render } from "./SolicitudInsumos.vue?vue&type=template&id=42ec7fd4&scoped=true"
import script from "./SolicitudInsumos.vue?vue&type=script&lang=js"
export * from "./SolicitudInsumos.vue?vue&type=script&lang=js"

import "./SolicitudInsumos.vue?vue&type=style&index=0&id=42ec7fd4&scoped=true&lang=scss"

import exportComponent from "E:\\laragon\\www\\proyectos\\laravel\\sandy_laravel_vue\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ec7fd4"]])

export default __exports__